import { useEffect, useState } from "react";

const useScroll = (element: HTMLElement | null) => {
  const [maxScroll, setMaxScroll] = useState<number>(0);
  const [currentScroll, setCurrentScroll] = useState<number>(0);
  const updateScrollState = () => {
    if (element) {
      setMaxScroll(element.scrollHeight - element.offsetHeight);
      setCurrentScroll(element.scrollTop);
    }
  };

  // init tracking of scroll state
  // only update if element has changed
  useEffect(() => {
    updateScrollState();
    if (element) {
      element.addEventListener("scroll", updateScrollState);
      return () => {
        element.removeEventListener("scroll", updateScrollState);
      };
    }
  }, [element]);

  const setScroll = (value: number) => {
    if (element) {
      element.scrollTo({ top: value, behavior: "smooth" });
    }
  };

  const scrollToBottom = () => {
    setScroll(maxScroll);
  };

  return { maxScroll, currentScroll, scrollToBottom, updateScrollState };
};

export default useScroll;
